<template>
  <div class="dhr-sideview">
    <h4 class="content-subtitle">QR-CODE</h4>
    <div class="qrcode">
      <qr-code v-if="data && (data.bonID || data.lotID)" class="print" :text='qrString' :size="180" error-level="L"/>
      <span v-else class="master-dhr">No QR-code available</span>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
   
  props: {
    data: Object
  },
  data () {
    return {
      qrString: ''
    }
  },
  mounted() {
    this.renderQR()
  },
  methods: {
    renderQR() {
      if(this.data.bonID == ""){
        this.qrString = '{"result": "' + this.data.lotID + '", "name": "' + this.data.lotID + '", "type": "LOT", "company": "SurgiTec"}'
      } else {
        this.qrString = '{"result": "' + this.data.bonID + '", "name": "' + this.data.bonID + '", "snummer": "' + this.data.snummer + '", "type": "BON", "company": "SurgiTec"}'
      }
    },
  },
  watch: {
    data: {
      handler: function() {
        this.renderQR();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";

.dhr-sideview{
  min-height: 240px;
}

span.master-dhr {
  color: #6A6A6A;
  font-style: italic;
  padding-top: 16px;
}

</style>